import { gql } from '../../__generated__/gql'

export const CHECK_EMAIL_AVAILABILITY_QUERY = gql(`
  query checkEmailAvailability($email: String!) {
    checkEmailAvailability(email: $email) {
      exists
      user {
        id
        email
        firstName
        lastName
      }
      hasPendingInvitation
      invitationOrganization
    }
  }
`)
